import { ResponseException } from "../../../Exceptions";
import { downloadFile } from "../../download";
import { request } from "../api";

export async function getLGUVisitsDraftData({ lgu, month, year }) {
    const response = await request("/data/visits/draft/", { query: { lgu, month, year } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function updateLGUVisitsDraftData({ lgu, month, year, attractions }) {
    const response = await request("POST /data/visits/draft/", 
        { query: { lgu, month, year }, body: { attractions } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getLGUVisitsSubmissions({ lgu, month, year }) {
    const response = await request("GET /data/visits/submission/", { query: { lgu, month, year } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function getProvinceVisitsSubmissions({ province, month, year }) {
    const response = await request("GET /data/visits/submission/province", { query: { province, month, year } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}



export async function getLGUVisitsSubmissionData(submissionId) {
    const response = await request(`/data/visits/submission/${submissionId}`);
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function updateLGUVisitsSubmissionData({ submissionId, attractions }) {
    const response = await request(`POST /data/visits/submission/${submissionId}`, 
        { body: { attractions } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function deleteLGUVisitsSubmissionData({ submissionId, password }) {
    const response = await request(`DELETE /data/visits/submission/${submissionId}`, { headers: { Password: password } });
    if(response.ok) return response.data;
    throw new ResponseException(response);
}


export async function submitLGUVisitsData({ lgu, month, year, attractions, remarks, password }) {
    const response = await request("POST /data/visits/submit", 
        { query: { lgu, month, year }, body: { attractions, remarks }, headers: { Password: password } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function approveLGUVisitsSubmissionData({ submissionId, password }) {
    const response = await request(`POST /data/visits/submission/${submissionId}/approve`, 
        { headers: { Password: password } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function unapproveLGUVisitsSubmissionData({ submissionId, password }) {
    const response = await request(`POST /data/visits/submission/${submissionId}/unapprove`, 
        { headers: { Password: password } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}



export async function publishLGUVisitsData({ lgu, month, year, attractions, password }) {
    const response = await request("POST /data/visits/publish", 
        { query: { lgu, month, year }, body: { attractions }, headers: { Password: password } });
        
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function downloadMonthlyLGUReport({ month, year, lgu, filename }) {
    const response = await request(`GET /data/visits/reports/1/`, 
        { query: { month, year, lgu }, parsing: "blob" });
        
    if(response.ok) return downloadFile(filename, response.data);
    
    throw new ResponseException(response);
}

export async function downloadAnnualAttractionReport({ attraction, year, filename }) {
    const response = await request(`GET /data/visits/reports/2/`, 
        { query: { attraction, year }, parsing: "blob" });
        
    if(response.ok) return downloadFile(filename, response.data);
    
    throw new ResponseException(response);
}

export async function downloadAnnualReport({ year, filename }) {
    const response = await request(`GET /data/visits/reports/3/`, 
        { query: { year }, parsing: "blob" });
        
    if(response.ok) return downloadFile(filename, response.data);
    
    throw new ResponseException(response);
}